class CommandArgument {
  static TYPES = ["STRING", "NUMBER", "BOOL", "STRING ARRAY", "NUMBER ARRAY"];

  name = undefined;
  description = undefined;
  type = CommandArgument.TYPES[0];
  constant = false;
  hasEnum = false;
  enum = undefined;
  value = undefined;
}

export default CommandArgument;
